import React, { useState } from 'react';
import './Gallery.css';

const Gallery = () => {
  // Sample gallery images - you can replace these with your actual images
  const galleryImages = [
    { id: 1, src: '/img/gallery/img1.png',   },
    { id: 2, src: '/img/gallery/img2.png',   },
    { id: 3, src: '/img/gallery/img3.png',   },
    { id: 4, src: '/img/gallery/img4.png',   },
    { id: 5, src: '/img/gallery/img5.png',   },
    { id: 6, src: '/img/gallery/img6.png',   },
    { id: 7, src: '/img/gallery/img7.png',   },
    { id: 8, src: '/img/gallery/img8.png',   },
    { id: 9, src: '/img/gallery/img9.png',   },
    { id: 10, src: '/img/gallery/img10.png',   },
    { id: 11, src: '/img/gallery/img11.png',   },
    // { id: 11, src: 'img/gallery/video/video1.mp4',   },
     
  ];

  const [selectedImage, setSelectedImage] = useState(null);

  // Find index of selected image
  const selectedIndex = selectedImage ? galleryImages.findIndex(img => img.id === selectedImage.id) : -1;

  // Arrow navigation handlers
  const showPrev = (e) => {
    e.stopPropagation();
    if (selectedIndex > 0) setSelectedImage(galleryImages[selectedIndex - 1]);
  };
  const showNext = (e) => {
    e.stopPropagation();
    if (selectedIndex < galleryImages.length - 1) setSelectedImage(galleryImages[selectedIndex + 1]);
  };

  // Keyboard navigation
  React.useEffect(() => {
    if (!selectedImage) return;
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') showPrev(e);
      if (e.key === 'ArrowRight') showNext(e);
      if (e.key === 'Escape') closeModal();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, selectedIndex]);

  const openModal = (image) => setSelectedImage(image);
  const closeModal = () => setSelectedImage(null);

  return (
    <div className="gallery-page">
      <div className="gallery-hero section">
        <div className="container">
          <div className="section-title">
            <h5>Our Gallery</h5>
            <h2>See Our Work in Action</h2>
            <p>Explore our gallery showcasing our eco-friendly car care solutions, professional services, and the amazing results we deliver for our customers.</p>
          </div>
        </div>
      </div>

      <div className="gallery-content section">
        <div className="container">
          <div className="gallery-grid">
            {galleryImages.map(image => (
              <div key={image.id} className="gallery-item">
                <div className="gallery-image" onClick={() => openModal(image)} style={{cursor: 'pointer'}}>
                  <img src={`${image.src}`} alt={image.alt} />
                  <div className="gallery-overlay">
                    
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Modal Popup */}
      {selectedImage && (
        <div className="gallery-modal" onClick={closeModal}>
          <div className="gallery-modal-content" onClick={e => e.stopPropagation()}>
            <button className="gallery-modal-close" onClick={closeModal}>&times;</button>
            {/* Left Arrow */}
            {selectedIndex > 0 && (
              <button className="gallery-modal-arrow left" onClick={showPrev} aria-label="Previous image">&#8592;</button>
            )}
            {/* Right Arrow */}
            {selectedIndex < galleryImages.length - 1 && (
              <button className="gallery-modal-arrow right" onClick={showNext} aria-label="Next image">&#8594;</button>
            )}
            <img src={selectedImage.src} alt={selectedImage.alt} className="gallery-modal-img" />
            <div className="gallery-modal-caption">
              <h4>{selectedImage.alt}</h4>
              <span className="category">{selectedImage.category}</span>
            </div>
          </div>
        </div>
      )}

      {/* Stats Section */}
      <section className="gallery-stats section" style={{ background: '#f7fafd' }}>
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">16</div>
              <div className="stat-label">Outlets</div>
              <p>Across major cities in Oman</p>
            </div>
            
            <div className="stat-item">
              <div className="stat-number">25+</div>
              <div className="stat-label">Years Experience</div>
              <p>In eco-friendly car care</p>
            </div>
            
            <div className="stat-item">
              <div className="stat-number">1000+</div>
              <div className="stat-label">Happy Customers</div>
              <p>Satisfied with our services</p>
            </div>
            
            <div className="stat-item">
              <div className="stat-number">50+</div>
              <div className="stat-label">Gallons Saved</div>
              <p>Per car wash on average</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery; 